import React from "react";
import ProductDisplayNameProps from "./Fields/ProductDisplayNameProps";
import {CurrencyFormatter, UnitFormatter} from "../formatters";
import {PropsRender} from "../../components/form/SelectorGrid/DataGrids/Types/PropsRender";
import {FieldDataProps} from "../../components/form/SelectorGrid/DataGrids/Types/FieldDataProps";
import {FieldProps} from "../../components/form/SelectorGrid/DataGrids/Types/FieldProps";

const sortable = true;
const filterable = true;

const productFields = ({product_id_field = "id", componentConfig} = {}): {
    [field: string]: {
        type?: PropsRender<FieldDataProps>,
        props: FieldProps
    }
} => ({
    [componentConfig.idfield]: {
        props: {
            header: "Kód",
            width: 1,
            sortable,
            filterable,
            order: "DESC",
        }
    },
    "displayname": {
        props: {
            ...ProductDisplayNameProps(product_id_field)
        }
    },
    "category.name": {
        props: {
            header: 'Árutípus',
            width: 1,
            sortable,
            filterable
        }
    },
    "sku": {
        props: {
            header: 'ISBN',
            width: 1,
            sortable,
            filterable
        }
    },
    "barcode": {
        props: {
            header: 'Vonalkód',
            width: 1,
            sortable,
            filterable
        }
    },
    "listprice": {
        props: {
            header: 'Listaár',
            width: 1,
            sortable,
            filterable,
            className: "currency",
            formatter: ({value}) => CurrencyFormatter(value)
        }
    },
    "qty": {
        props: {
            header: 'Darabszám',
            width: 1,
            sortable,
            filterable,
            formatter: ({value, row}) => UnitFormatter(value || 0, row.unit),
            className: "unit"
        }
    },
});

const LabelFields = ({componentConfig} = {}): {
    [field: string]: {
        type?: PropsRender<FieldDataProps>,
        props: FieldProps
    }
} => ({
    [componentConfig.idfield]: {
        props: {
            header: "Kód",
            width: 1,
            sortable,
            filterable,
            order: "DESC",
        }
    },
    component_type: {
        props: {
            header: "Komponens",
            width: 2,
            sortable,
            filterable,
        }
    },
    component_id: {
        props: {
            header: "Komponens kód",
            width: 2,
            sortable,
            filterable,
        }
    },
    text: {
        props: {
            header: "Címke",
            width: 7,
            sortable,
            filterable,
        }
    }
});

export {
    productFields,
    LabelFields
}